import React, { Fragment } from 'react';
import ContactModal from 'src/components/ContactModal';
import invoiceImage from 'src/images/invoice.svg';
import {
  Alert,
  Button,
  Card,
  CardBody,
  Col,
  Icon,
  Row,
  useApp
} from 'straightline-ui';
import { DOCUMENT_TYPE } from 'straightline-utils/constants';

import { ShipmentDispatch } from './details';

export default function ShipmentTransferTab({ shipment }) {
  const app = useApp();

  const {
    result: transfers,
    isLoading: transfersLoading,
    isError: transfersError
  } = app.service('api/shipment-transfers').useFind(
    {
      $include: ['transfer_method', 'shipment'],
      query: { shipment_id: shipment.id, $sort: { created_at: -1 } }
    },
    { keepPreviousData: true }
  );

  const {
    result: podDocument,
    isLoading: podLoading,
    isError: podError
  } = app.service('api/shipment-documents').useFindOne(
    {
      query: {
        shipment_id: shipment.id,
        '$document.document_type$': DOCUMENT_TYPE.PROOF_OF_DELIVERY,
        $sort: { created_at: -1 }
      }
    },
    { keepPreviousData: true }
  );

  if (transfersLoading || podLoading) {
    return null;
  }

  if (transfersError || podError) {
    return <Alert color="info">There is no transfer yet.</Alert>;
  }

  if (!shipment.shipment_dispatch_id) {
    return (
      <Row>
        <Col xl="8">
          <Card>
            <ShipmentDispatch shipment={shipment} />
          </Card>
        </Col>
      </Row>
    );
  }

  if (!transfers.total) {
    return (
      <Row>
        <Col xl="4" className="order-xl-2">
          <Card className="">
            <CardBody>
              <Row className="d-flex justify-content-between mb-3">
                <Col className="mb-1">
                  <div className="h3 mb-0 d-flex align-items-center">
                    <Icon type="dollar-sign" className="mr-3"></Icon>Rate
                    Confirmation
                  </div>
                </Col>
              </Row>
              <div>
                The Rate Confirmation will be available here once the shipment
                has been dispatched. You will receive an email with the Rate
                Confirmation attached as soon as it is ready. Download the file
                for your records and use it to initiate payments with your
                factoring company or Straightline.
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl="8">
          <div
            style={{
              opacity: 0.4,
              width: '100%',
              overflow: 'hidden',
              maskImage:
                'linear-gradient(to bottom, black 50%, transparent 100%)'
            }}
          >
            <img
              src={invoiceImage}
              style={{ width: '100%' }}
              alt="No Results"
            />
          </div>
        </Col>
      </Row>
    );
  }

  const latestTransfer = transfers.data[0];

  return (
    <Fragment>
      <Row>
        <Col xl="4" className="order-xl-2">
          <Card>
            <CardBody className="border-bottom">
              <Row className="d-flex justify-content-between mb-3">
                <Col className="mb-1">
                  <div className="h3 mb-0 d-flex align-items-center">
                    <Icon type="dollar-sign" className="mr-3"></Icon>Rate
                    Confirmation
                  </div>
                </Col>
              </Row>
              <div className="mb-3">
                Download the Rate Confirmation for your records. Use this
                document to initiate payments with your factoring company or
                Straightline. Click "Request Payment" to add factoring or other
                payment methods.
              </div>
              <div className="">
                <Button
                  color="primary"
                  block
                  tag="a"
                  href={`${latestTransfer.secure_url}?download=true`}
                >
                  Download Rate Confirmation
                </Button>
                {podDocument && (
                  <Button
                    color="white"
                    block
                    tag="a"
                    href={`${podDocument.document.download_url}`}
                  >
                    Download POD
                  </Button>
                )}
                <ContactModal
                  header="Request Payment Assistance"
                  text={
                    <div>
                      <p>
                        Let us know how you would like to proceed with payment
                        for this shipment. Add factoring details or request a
                        different payment method.
                      </p>
                      <p className="text-danger">
                        Do not include any sensitive information such as account
                        numbers or personal details in this message.
                      </p>
                    </div>
                  }
                  config={{
                    subject: `Carrier Payment Contact - Shipment #${shipment.id}`,
                    service: 'api/shipments',
                    service_id: shipment.id
                  }}
                >
                  {(toggle) => (
                    <Button color="white" block onClick={toggle}>
                      Request Payment
                    </Button>
                  )}
                </ContactModal>
              </div>
            </CardBody>
          </Card>
        </Col>
        <Col xl="8">
          {transfers.data.map((shipmentTransfer, index) => {
            return (
              <div className="mb-4" key={shipmentTransfer.id}>
                <embed
                  src={shipmentTransfer.secure_url}
                  type="application/pdf"
                  className="rounded border shadow"
                  style={{
                    width: '100%',
                    height: '1200px'
                  }}
                ></embed>
              </div>
            );
          })}
        </Col>
      </Row>
    </Fragment>
  );
}
